// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__Xw6Qv","tab":"Tabs_tab__2_78T","tabActive":"Tabs_tabActive__3WtV2"};